/**
 * Página de Gestión de Notificaciones para Administradores.
 * Actúa como contenedor principal para la configuración de destinatarios de alertas,
 * envolviendo el componente especializado dentro del diseño administrativo (AdminLayout).
 */

import React from 'react';
import AdminLayout from './AdminLayout';
import AdminNotificationSettings from './AdminNotificationSettings';

const AdminNotificationsPage = () => {
    return (
        <AdminLayout
            breadcrumb="Panel de Administración / Configuración / Notificaciones"
            title="Suministro de Correos para Alertas"
        >
            <AdminNotificationSettings />
        </AdminLayout>
    );
};

export default AdminNotificationsPage;
